import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const getCustomerDetail = (state: AppState) => state.contactsAndOrganizations.customers.customerDetail;

export const customerEmployeeTopicsSelector = createSelector(getCustomerDetail, state => state.topics.employeeTopics);
